import {Message} from "element-ui";

let messageObj: any = null;

export default class {
  static error(message: string, duration: number = 3000,customClass:string="") {
    messageObj && messageObj.close();
    messageObj = Message({
      type: "error",
      message: message,
      duration: duration,
      showClose: true,
      customClass
    });
  }

  static warning(message: string, duration: number = 3000,customClass:string="") {
    messageObj && messageObj.close();
    messageObj = Message({
      type: "warning",
      message: message,
      duration: duration,
      showClose: true,
      customClass
    });
  }

  static success(message: string, duration: number = 3000,customClass:string="") {
    messageObj && messageObj.close();
    messageObj = Message({
      type: "success",
      message: message,
      duration: duration,
      showClose: true,
      customClass
    });
  }

  static info(message: string, duration: number = 3000,customClass:string="") {
    messageObj && messageObj.close();
    messageObj = Message({
      message: message,
      duration: duration,
      showClose: true,
      customClass
    });
  }
}
